import { getApplication } from "./get_application";
import { getController } from "./get_controller";

export default { getApplication, getController };
